import React from "react";
import { ListItem, ListItemText } from "@mui/material";

function DateTile({ date }) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = date.toLocaleString("default", { month: "short" });
    

    return `${month} ${year}`;
  }
  return (
    <ListItem
      sx={{
        background: "#F8F8F8",
      }}
    >
      <ListItemText
        primary={formatDate(date)}
        primaryTypographyProps={{
          color: "#4D4D4D",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: "700",
          fontSize: "16px",
        }}
      />
    </ListItem>
  );
}
export default DateTile;
